const ViewManufacturerDetail = () => {
    return (
        <div>View Manufacturer Detail</div>
    )
}

export default ViewManufacturerDetail